import { API_ROOT } from '../../config/config'
import { doGet, doPost } from './utils'

// /api/review/reviewer/payment/page

const API_ROOT_VER = `${API_ROOT}/review`

export const getExpertPayment = (pageNumber, pageSize) => {
  const url = `${API_ROOT_VER}/reviewer/payment/page?pageNumber=${pageNumber || 0}&pageSize=${
    pageSize || 0
  }`

  return doGet(url)
}

export const searchExpertPayment = (request, pageNumber, pageSize) => {
  const url = `${API_ROOT_VER}/reviewer/payment/search?pageNumber=${pageNumber || 0}&pageSize=${
    pageSize || 0
  }`

  return doPost(url, request)
}

// /api/review/reviewer/payment/search
